
/**
 * 업데이트된 강의 상세 정보 응답 (강의 초안용)
 */
export type UpdateDraftLectureContent200 = {
  /** 강의 ID */
  id: number;
  /**
   * 저장된 마크다운 내용
   * @nullable
   */
  markdownContent?: string | null;
  /** 강의 제목 */
  title: string;
  /** 최종 수정 시간 */
  updatedAt?: string;
};
